import { Country } from "../lib/country";
import { today } from "./dates";

const countryData: Country[] = require("../data/country_data.json").features;
const populations: Record<string, number> = require("../data/populations.json");

// Build a pool of countries eligible to be an answer (population > 500,000)
const answerPool: Country[] = countryData.filter((c) => {
  const name = c.properties.NAME;
  return populations[name] && populations[name] > 500000;
});

answerPool.sort((a, b) => {
  return a.properties.FLAG[1].localeCompare(b.properties.FLAG[1]);
});

// Use answerPool for the answer; fall back to countryData if pool is empty
const pool = answerPool.length ? answerPool : countryData;
const key = Math.floor(Math.random() * pool.length);

export const answerCountry = pool[key];
export const answerName = answerCountry.properties.NAME;

export function getRandomAnswer(excludeName?: string): Country {
  const pool = answerPool.length ? answerPool : countryData;
  let candidates = pool;
  if (excludeName) {
    candidates = pool.filter((c) => c.properties.NAME !== excludeName);
  }
  if (candidates.length === 0) candidates = pool;
  return candidates[Math.floor(Math.random() * candidates.length)];
}
